module.exports = __webpack_public_path__ + "img/dropdown.1ee7ab02.svg";